export default __webpack_public_path__ + "static/divinedao-5b313f454441673806e73751e599e6fd.gif";